import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, Phone, MessageCircle, Home } from "lucide-react";
import { motion } from "framer-motion";
import Seo from "../components/Seo";
import { company, whatsappUrl } from "../data/site";

export default function AnfrageErfolgreich() {
  const location = useLocation();
  const number = location.state?.number;
  return (
    <div data-testid="page-anfrage-erfolgreich">
      <Seo path="/anfrage-erfolgreich" title="Anfrage erfolgreich | Rümpeltaxi" noindex />
      <section className="flex min-h-[80vh] items-center bg-brand-black grain">
        <div className="container-page relative z-10 py-24 text-center">
          <motion.span
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: "spring", stiffness: 200, damping: 15 }}
            className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-yellow"
          >
            <CheckCircle2 className="h-11 w-11 text-brand-black" />
          </motion.span>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15, duration: 0.6 }}
            className="mx-auto mt-8 max-w-2xl font-heading text-4xl font-extrabold tracking-tight text-white md:text-5xl"
          >
            Vielen Dank für Ihre Anfrage
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.25, duration: 0.6 }}
            className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-light-gray/70 md:text-lg"
          >
            Ihre Anfrage wurde erfolgreich an Rümpeltaxi übermittelt. Wir melden uns schnellstmöglich
            persönlich bei Ihnen.
          </motion.p>
          {number && (
            <motion.p
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.35, duration: 0.5 }}
              className="mx-auto mt-6 inline-flex items-center gap-2 rounded-sm border border-yellow/40 bg-yellow/10 px-5 py-3 text-sm text-white"
              data-testid="success-reference"
            >
              Ihre Anfrage-Nr.: <span className="font-heading text-lg font-bold text-yellow">{number}</span>
            </motion.p>
          )}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.45, duration: 0.6 }}
            className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row"
          >
            <a
              href={company.phoneLink}
              className="inline-flex items-center gap-2 rounded-sm bg-yellow px-6 py-3.5 font-heading font-bold text-brand-black transition-colors hover:bg-yellow-dark"
              data-testid="success-call"
            >
              <Phone className="h-4 w-4" /> {company.phoneDisplay}
            </a>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-sm border border-dark-gray bg-anthracite px-6 py-3.5 font-heading font-bold text-white transition-colors hover:bg-dark-gray"
              data-testid="success-whatsapp"
            >
              <MessageCircle className="h-4 w-4" /> WhatsApp öffnen
            </a>
            <Link
              to="/"
              className="inline-flex items-center gap-2 rounded-sm border border-dark-gray bg-anthracite px-6 py-3.5 font-heading font-bold text-white transition-colors hover:bg-dark-gray"
              data-testid="success-home"
            >
              <Home className="h-4 w-4" /> Zur Startseite
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
